export class AuditActivator {
    id: number;
    source: string;
    action: string;
    detail: string;
    result: string;
    usr: string;
    datetime: string;
}
